<template>
	<v-tab-item>
		<v-card flat>
			<h3 class="text-h6 font-weight-bold">回答</h3>
			<v-sheet elevation="0" class="pa-2" v-if="answerAvailable">
				<table width="100%" class="show-dialog-table">
					<tbody>
						<!-- <tr>
							<th width="30%" class="font-weight-bold">回答名</th>
							<td width="70%" class="no-wrap">
								{{ answer.answer_template.name }}
							</td>
						</tr> -->
						<tr>
							<th width="30%" class="font-weight-bold">状態</th>
							<td width="70%" class="no-wrap">
								{{ answer.status_id_i18n }}
								<v-icon
									v-if="
										answerAuthorityFlag &&
										(answer.status_id == 'draft' || answer.status_id == 'refused')
									"
									class="float-right"
									@click="openConfirm()"
								>
									mdi-send
								</v-icon>
							</td>
						</tr>
						<tr>
							<th width="30%" class="font-weight-bold">回答日</th>
							<td width="70%" class="no-wrap">
								{{ answer.answer_date ? common.formatDate(answer.answer_date) : "" }}
							</td>
						</tr>
						<tr>
							<th width="30%" class="font-weight-bold">依頼元部門</th>
							<td width="70%" class="no-wrap">
								{{
									$store.getters.department(requirement.from_department_id)
										? $store.getters.department(requirement.from_department_id).name
										: ""
								}}
							</td>
						</tr>
						<tr>
							<th width="30%" class="font-weight-bold">依頼者</th>
							<td width="70%" class="no-wrap">
								{{ requirement.user.full_name }}
							</td>
						</tr>
						<tr>
							<th width="30%" class="font-weight-bold">回答部門</th>
							<td width="70%" class="no-wrap">
								{{
									$store.getters.department(requirement.to_department_id)
										? $store.getters.department(requirement.to_department_id).name
										: ""
								}}
							</td>
						</tr>
						<tr>
							<th width="30%" class="font-weight-bold">担当者</th>
							<td width="70%" class="no-wrap">
								{{ requirement.responder != null ? requirement.responder.full_name : "未定" }}
							</td>
						</tr>
						<tr v-if="answer.answer_template.need_check_flag">
							<th width="30%" class="font-weight-bold">確認者</th>
							<td width="70%" class="no-wrap" v-if="answer.confirmations.length">
								<p
									class="no-wrap"
									v-for="confirmation in answer.confirmations"
									:key="'confirmation-' + confirmation.id"
								>
									{{ confirmation.user.full_name }}
									<span class="fs0875">{{ common.formatDate(confirmation.created_at) }}</span>
								</p>
							</td>
							<td width="70%" class="no-wrap" v-else></td>
						</tr>
						<tr v-if="answer.answer_template.need_approval_flag">
							<th width="30%" class="font-weight-bold">承認者</th>
							<td width="70%" class="no-wrap" v-if="answer.approvals">
								<p
									class="no-wrap"
									v-for="approval in answer.approvals"
									:key="'approval-' + approval.id"
								>
									{{ approval.user.full_name }}
									<span class="fs0875">{{ common.formatDate(approval.created_at) }}</span>
								</p>
							</td>
							<td width="70%" class="no-wrap" v-else></td>
						</tr>
						<tr>
							<th width="30%" class="font-weight-bold">
								伝達事項
								<v-icon class="float-right" v-if="fixed('message')">mdi-clock-edit-outline</v-icon>
							</th>
							<td width="70%" class="no-wrap">
								<div class="pre-wrap" v-text="answer.message"></div>
								<v-icon
									v-if="answerAuthorityFlag"
									class="float-right"
									@click="openAnswerEditDialog('伝達事項', 'text', 'message')"
									>mdi-pencil-box</v-icon
								>
							</td>
						</tr>
						<tr v-for="column in answer.answer_template.answer_columns" :key="column.id">
							<th width="30%" class="font-weight-bold">
								{{ column.name }}
								<v-icon class="float-right" v-if="valueFixed(valueByColumn(column))"
									>mdi-clock-edit-outline</v-icon
								>
							</th>
							<td width="70%" class="no-wrap" v-if="column.data_type == 'file'">
								<v-btn
									color="transparent"
									class="no-shadow no-border pa-1"
									@click="openFilesDialog(valueByColumn(column))"
								>
									<v-icon>mdi-folder-outline</v-icon>
									{{
										checkFileExist(lodashGet(valueByColumn(column), "attached_files"))
											? "内容を確認する"
											: "アップロードする"
									}}
								</v-btn>
								<p
									class="no-wrap"
									style="font-size: 0.875rem"
									v-if="!checkFileExist(lodashGet(valueByColumn(column), 'attached_files'))"
								>
									添付ファイルはありません
								</p>
							</td>
							<td width="70%" class="no-wrap" v-else-if="column.data_type == 'text'">
								<div class="pre-wrap" v-text="value(column)"></div>
								<v-icon
									v-if="answerAuthorityFlag"
									class="float-right"
									@click="openValueEditDialog(valueByColumn(column), column)"
									>mdi-pencil-box</v-icon
								>
							</td>
							<td width="70%" class="no-wrap" v-else-if="column.data_type != 'synchronization'">
								{{ value(column) }}
								<v-icon
									v-if="answerAuthorityFlag"
									class="float-right"
									@click="openValueEditDialog(valueByColumn(column), column)"
									>mdi-pencil-box</v-icon
								>
							</td>
							<td width="70%" class="no-wrap" v-else-if="column.data_type == 'synchronization'">
								<RubberProcessShowDialog
									v-if="column.data_synchronization.reflect_model == 'RubberProcess'"
									:id="synchronizationModelId(column)"
									:is_draft="!!valueByColumn(column).value.synchronized_datum"
									:showEditBtn="false"
									requiredDialogBtn
								>
									<template v-slot:open-btn="{ openDialog }">
										<a @click="openDialog">
											{{ value(column) }}
										</a>
									</template>
								</RubberProcessShowDialog>
								<v-icon
									v-if="answerAuthorityFlag"
									class="float-right"
									@click="openValueEditDialog(valueByColumn(column), column)"
									>mdi-pencil-box</v-icon
								>
							</td>
						</tr>
					</tbody>
				</table>
				<FilesDialog ref="files" @set-files="setFiles" />
				<AnswerSmallEditDialog ref="edit" @update-answer="updateAnswer($event)" />
				<AnswerValueSmallEditDialog
					ref="editValue"
					@update-answer-values="updateAnswerValues($event)"
				/>
				<ChangeStatusFromDraft ref="changeFromDraft" @reloadShow="reloadShow" />
			</v-sheet>
			<v-sheet elevation="0" class="pa-2" v-else>
				<p class="align-center">回答はまだ作成されていません。</p>
				<v-row no-gutters justify="center" v-if="answerable">
					<v-btn
						color="secondary"
						@click="$router.push({ name: 'answer_new', params: { id: requirement.id } })"
						><v-icon class="mr-1">mdi-plus</v-icon>回答する</v-btn
					>
				</v-row>
			</v-sheet>
		</v-card>
	</v-tab-item>
</template>

<script>
import common from "../../../../helper/common"
import lodashGet from "lodash/get" // templateのオプショナルチェーン用
import FilesDialog from "../../../answers/components/AnswerValueFilesDialog.vue"
import AnswerSmallEditDialog from "../../../answers/components/AnswerSmallEditDialog.vue"
import AnswerFixHistoryDialog from "../../../answers/components/AnswerFixHistoryDialog.vue"
import AnswerValueSmallEditDialog from "../../../answers/components/AnswerValueSmallEditDialog.vue"
import ChangeStatusFromDraft from "../../../answers/components/ChangeStatusFromDraft.vue"

export default {
	props: {
		answer_data: {
			type: null,
			required: true,
		},
		requirement_data: {
			type: Object,
			required: true,
		},
		answerAuthorityFlag: {
			type: Boolean,
			required: false,
			default: false,
		},
		isFetched: {
			type: Boolean,
		},
	},
	components: {
		FilesDialog,
		AnswerSmallEditDialog,
		AnswerFixHistoryDialog,
		AnswerValueSmallEditDialog,
		ChangeStatusFromDraft,
		RubberProcessShowDialog: () =>
			import("../../../rubber_process/components/RubberProcessShowDialog.vue"),
	},
	data() {
		return { common, lodashGet }
	},
	methods: {
		openAnswerEditDialog(label, dataType, keyword) {
			let dataSet = {
				answer: this.answer,
				label: label,
				dataType: dataType,
				dataKey: keyword,
				user: this.$store.getters["auth/authData"],
			}
			this.$refs.edit.setEditData(dataSet)
		},
		openCreateAnswer() {
			this.$router.push({ name: "answer_new", params: { id: this.requirement.id } })
		},
		reloadShow(answer) {
			this.answer.status_id_i18n = answer.status_id_i18n
			this.answer.status_id = answer.status_id
			this.answer.answer_date = answer.answer_date
		},
		openConfirm() {
			this.$refs.changeFromDraft.openDialog(this.answer.id)
		},
		openFilesDialog(value) {
			this.$refs.files.openDialog(value.id)
		},
		diffDate(deadline) {
			let today = moment(new Date())
			let gap = moment(deadline).diff(today, "days")
			if (gap <= 5) {
				return true
			} else {
				return false
			}
		},
		openValueEditDialog(value, column) {
			let dataSet = {
				value: value,
				answer: this.answer,
				column: column,
				user: this.$store.getters["auth/authData"],
			}
			this.$refs.editValue.setEditData(dataSet)
		},
		updateAnswer(answer) {
			this.answer[answer.changed_column] = answer.data[answer.changed_column]
			if (answer.fix) {
				this.answer.answer_fixes.push(answer.fix)
			}
			this.$emit("update-answer", this.answer)
		},
		updateAnswerValues(data) {
			let answerValue = this.answer.answer_values.find((v) => v.id == data.value.id)
			if (!answerValue) return
			const index = this.answer.answer_values.indexOf(answerValue)
			answerValue.value = data.value.value
			if (data.fix) answerValue.answer_value_fixes.push(data.fix)
			this.answer.answer_values[index] = answerValue
			this.$emit("update-answer", this.answer)
		},
		setFiles(files, id) {
			const value = this.answer.answer_values.find((v) => v.id == id)
			if (!value) return
			const index = this.answer.answer_values.indexOf(value)
			this.answer.answer_values[index].attached_files = files
		},

		valueByColumn(column) {
			return this.answer.answer_values.find((v) => v.answer_column_id == column.id)
		},
		value(column) {
			return common.value(column, this.valueByColumn(column)?.value)
		},
		synchronizationModelId(column) {
			let value = this.valueByColumn(column)?.value
			return value?.synchronized_datum?.id || value?.model?.id
		},
	},
	computed: {
		answer: {
			get() {
				return this.answer_data
			},
			set(newVal) {
				return this.$emit("update:answer_data", newVal)
			},
		},
		requirement: {
			get() {
				return this.requirement_data
			},
			set(newVal) {
				return this.$emit("update:requirement_data", newVal)
			},
		},
		fixed() {
			return (columnName) => {
				return this.answer.answer_fixes.find((fix) => fix[columnName] != null) != null
			}
		},
		valueFixed() {
			return (value) => {
				if (value == null) return null
				return value.answer_value_fixes?.length
			}
		},
		checkFileExist() {
			return (attachedFiles) => {
				if (attachedFiles == null || attachedFiles == []) return false
				return attachedFiles.filter((file) => !file.destroy_flag).length > 0
			}
		},

		// 回答する権利があるかどうか
		answerable() {
			if (this.answerAuthorityFlag && this.requirement.status_id == "sent") {
				return true
			} else {
				return false
			}
		},
		// 回答を見れるかどうか
		answerAvailable() {
			if (this.answer) {
				return true
			} else {
				return false
			}
		},
	},
	watch: {
		deep: true,
	},
}
</script>
